import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox, FormControlLabel } from '@mui/material';
import { useFormContext, Controller } from 'react-hook-form';
function FormCheckbox({ name, label, rules, ...checkboxProps }) {
    const { control } = useFormContext();
    return (_jsx(Controller, { name: name, control: control, rules: rules, render: ({ field }) => (_jsx(FormControlLabel, { control: _jsx(Checkbox, { ...field, ...checkboxProps, checked: field.value, onChange: (e) => {
                    field.onChange(e.target.checked);
                    if (checkboxProps.onChange) {
                        checkboxProps.onChange(e, e.target.checked);
                    }
                } }), label: label })) }));
}
FormCheckbox.defaultProps = {
    rules: {}
};
export default FormCheckbox;
